import React, { useId, useState } from 'react'

import {
  Icon, ChevronUp, ChevronDown, InfoOutlined,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, node, string } from 'prop-types'

import SmartTooltip from 'Pods/ItemPage/Components/SmartTooltip'

function CollapsibleSection({
  title, children, defaultOpen = true, tooltip = '',
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const reactId = useId()
  const tooltipId = `more-filters-section-tooltip-${reactId.replace(/:/g, '')}`

  const handleTooltipTriggerClick = (event) => {
    // The trigger lives inside the section header button. Stop the click from bubbling so it
    // doesn't toggle the section; react-tooltip opens the tooltip via its own event="click"
    // listener on the trigger (the drawer is touch-only, so hover is not reliable).
    event.preventDefault()
    event.stopPropagation()
  }

  return (
    <div className="more-filters__section">
      <button
        type="button"
        className="more-filters__section-header cgt-overline-md"
        onClick={() => setIsOpen(o => !o)}
        aria-expanded={isOpen}
      >
        <span className="more-filters__section-title">
          <span>{title}</span>
          {tooltip && (
            <SmartTooltip
              content={tooltip}
              id={tooltipId}
              place="right"
              event="click"
              globalEventOff="click"
              delayShow={0}
              wrapperTag="span"
              tooltipClassName="quality-filter__tooltip"
              className="more-filters__section-tooltip-trigger"
              onClick={handleTooltipTriggerClick}
            >
              <Icon svgComponent={InfoOutlined} size="small" color="dark" notSpaced />
            </SmartTooltip>
          )}
        </span>
        <Icon
          notSpaced
          svgComponent={isOpen ? ChevronUp : ChevronDown}
          color="darker"
          size="small"
        />
      </button>
      {isOpen && <div className="more-filters__section-content">{children}</div>}
    </div>
  )
}

CollapsibleSection.propTypes = {
  title: string.isRequired,
  children: node.isRequired,
  defaultOpen: bool,
  tooltip: string,
}

export default CollapsibleSection
